module.exports = __webpack_public_path__ + "img/00.b0ee99f6.jpg";